// extracted by mini-css-extract-plugin
export default {"empty":"AssignmentsTable_empty__NBKik"};